import { useEffect } from "react";
import PropTypes from "prop-types";
import Image from "../image/image";
import config from "../../../config/index";
import styles from "./ResultInformation.module.scss";
import * as Analytics from "../../../services/analyticsUtag";

const ResultInformation = ({
  analyticsType,
  iconType,
  title,
  desc,
  className,
  formName,
  pageName,
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const getIcon = () => {
    let icon;
    switch (iconType) {
      case "failed":
        icon = "lock.svg";
        break;
      case "success":
        icon = "success-circle.svg";
        break;
      case "loading":
        icon = "lock-loading.gif";
        break;
    }
    return `${imagePrefix}/assets/images/${icon}`;
  };

  useEffect(() => {
    if (pageName && formName && analyticsType) {
      Analytics.view({
        page_event: "view",
        page_name: `${pageName}: ${formName} ${analyticsType}`,
        ...Analytics.getUtagData([
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
      });
    }
  }, [iconType]);

  return (
    <div className={`${styles["main-container"]} ${className}`}>
      <div className={styles["icon"]}>
        <Image img_path={getIcon()} />
      </div>
      <div className={styles["title"]}> {title} </div>
      {desc && <div className={styles["desc"]}> {desc} </div>}
    </div>
  );
};

ResultInformation.propTypes = {
  analyticsType: PropTypes.string,
  iconType: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  className: PropTypes.string,
  formName: PropTypes.string,
};

ResultInformation.defaultProps = {
  analyticsType: "checking loading",
  iconType: "loading",
  title: "Your application has been successfully authenticated",
  desc: null,
  formName: null,
  pageName: null,
};

export default ResultInformation;
